import $ from 'jquery';

const $promos = $('.promos-img-url');

const qty = $promos.length;

if (qty != 0) {
  $promos.each(function (index) {


    const url = $(this).data('img');
    const model = $(this).data('model');
    let image = new Image();

    image.onload = function (obj) {
      $(`.promo-${model}`).removeClass('hidden').find('img').removeClass('hidden');
      $('.promos-scene').remove();
    };

    image.onerror = function () {
      $(`.promo-${model}`).remove();
      if (index == (qty - 1)) {
        $('.promos-scene-no-results').removeClass('hidden');
      }
    };

    image.src = url;
  });
} else {
  $('.promos-scene').remove();
}

// $('.promos-img-url-mobile').each(function () {

//   const url = $(this).data('img');
//   const model = $(this).data('model');
//   let image = new Image();

//   image.src = url;
//   console.log(image);

// });
